import { cx } from "cva";
import React from "react";
import { BuildHtml } from "~/components/BuildHtml";
import { SocialMediaShareFlyout } from "~/components/SocialMediaShareFlyout";
import { SocialMediaShareFlyoutButton } from "~/components/SocialMediaShareFlyout/SocialMediaShareFlyoutButton";
import { SocialMediaShareMenu } from "~/components/SocialMediaShareMenu";
import { SocialMediaShareMenuButton } from "~/components/SocialMediaShareMenu/SocialMediaShareMenuButton";
import { TagToClassNameMap } from "~/lib/shared/html-utils";
import { Headline } from "~/ui-library";
import { getButtonStyles } from "~/ui-library/shared-styles/shared-button-styles";
import {
  ReportPreviewDownloadButton,
  ReportPreviewDownloadButtonProps,
} from "../ReportPreviewDownloadButton";

export type ReportPreviewContentSummaryProps = {
  /** Expected html string to be rendered underneath the headline "About This Report" */
  contentHtml: string;
  /** h4 title to be rendered */
  title: string;
  shareTitle: string;
  shareUrl: string;

  downloadButtonProps: ReportPreviewDownloadButtonProps;
};

const tagsToClassNameMap: TagToClassNameMap = new Map([
  // reset default br sizing and apply 8px between each item
  ["br", "block content-[''] text-body-xsmall h-xxs"],
  ["li", "list-disc list-inside mb-xxs last:mb-0"],
]);

const shareButtonStyles = cx(
  "text-center",
  getButtonStyles({
    fullWidth: true,
    variant: "default",
  })
);
export const ReportPreviewContentSummary: React.FC<
  ReportPreviewContentSummaryProps
> = ({ contentHtml, title, shareTitle, shareUrl, downloadButtonProps }) => (
  <>
    <div
      data-testid="parent-div"
      className={cx(
        "relative",
        "text-body-small",
        "bg-white",
        "p-m pt-l",
        "border-1 border-gray-300",
        "border-t-2 border-t-brand-green"
      )}
    >
      {contentHtml ? (
        <div className="mb-l">
          <Headline as="h4" level={4}>
            {title}
          </Headline>

          <BuildHtml
            html={contentHtml}
            tagToClassNameMap={tagsToClassNameMap}
          />
        </div>
      ) : null}

      <div className="flex flex-col gap-m">
        <ReportPreviewDownloadButton {...downloadButtonProps} />

        <div className="hidden lg:block">
          <SocialMediaShareMenu
            menuButton={
              <SocialMediaShareMenuButton className={shareButtonStyles} />
            }
            shareTitle={shareTitle}
            shareUrl={shareUrl}
          />
        </div>

        <div className="lg:hidden">
          <SocialMediaShareFlyout
            shareTitle={shareTitle}
            shareUrl={shareUrl}
            renderButton={({ onClick }) => (
              <SocialMediaShareFlyoutButton
                className={shareButtonStyles}
                onClick={onClick}
              />
            )}
          />
        </div>
      </div>
    </div>
  </>
);
